/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '~/components/button';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import Tabs from '~/components/tab';
import useApi from '~/hooks/useApi';
import { ReprocessamentoFaturaSolicitacaoDetalhes } from '~/models/reprocessamento-fatura';
import Endpoints from '~/services/endpoints';
import { FormField, setFormState } from '~/utils/form';
import InvoiceView from '../components/invoiceView';
import { useInvoiceReprocess } from '../context';
import * as St from '../styles';

interface Form {
  cpf: FormField;
  numeroCartao: FormField;
  nome: FormField;
}
const formInitialState = {
  cpf: { name: 'cpf', value: '' },
  numeroCartao: { name: 'numeroCartao', value: '' },
  nome: { name: 'nome', value: '' },
};
const InvoiceReprocessPendingDetails = () => {
  const history = useHistory();
  const [list, setList] = useState([]);
  const [form, setForm] = useState<Form>(formInitialState);
  const { state } = useLocation<{ id?: string }>();
  const { solicitationData, setSolicitationData } = useInvoiceReprocess();
  const GetSolicitationDetails = useApi<ReprocessamentoFaturaSolicitacaoDetalhes>(
    {
      url: Endpoints.reprocess.getSolicitationDetails.replace(
        'PARAM_ID',
        state?.id,
      ),
      tryNewWay: true,
      fetchOnMount: true,
      enabled: !!state?.id,
    },
  );
  useEffect(() => {
    if (GetSolicitationDetails.data) {
      setSolicitationData({ ...GetSolicitationDetails.data, id: state?.id });
    }
  }, [GetSolicitationDetails.data]);

  if (GetSolicitationDetails.isFetched && GetSolicitationDetails.error) {
    return (
      <Container>
        <St.BoxCard>
          <St.BoxCardTitle>
            Houve um erro ao buscar os dados da solicitação
          </St.BoxCardTitle>
          <Button
            loading={GetSolicitationDetails.loading}
            disabled={GetSolicitationDetails.loading}
            onClick={() => GetSolicitationDetails.refetch()}
          >
            Tentar novamente
          </Button>
        </St.BoxCard>
      </Container>
    );
  }
  return (
    <>
      <Container>
        <Loading status={GetSolicitationDetails.loading} />

        <St.BoxCard>
          <St.BoxCardTitle>Dados do cliente</St.BoxCardTitle>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                value={GetSolicitationDetails.data?.cliente?.cpf}
                onChange={(e) => setFormState(e, form, setForm)}
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                value={GetSolicitationDetails.data?.cliente?.numeroCartao}
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <Input
                label="Nome"
                onChange={(e) => {}}
                name={'clientName'}
                value={GetSolicitationDetails.data?.cliente?.nome}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Status do cartão "
                onChange={(e) => {}}
                name={'clientCardStatus'}
                value={GetSolicitationDetails.data?.cliente?.statusCartao}
              />
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
        <St.BoxCard>
          <St.BoxCardTitle>Dados do solicitante</St.BoxCardTitle>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="Data solicitação"
                value={moment(
                  GetSolicitationDetails.data?.dataSolicitacao,
                ).format('DD/MM/YYYY HH:mm:ss')}
                onChange={(e) => setFormState(e, form, setForm)}
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Nome operador"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                value={GetSolicitationDetails.data?.nomeSolicitante}
              />
            </ContainerFlex>

            <ContainerFlex padding={16}>
              <Input
                label="Nr do chamado"
                onChange={(e) => {}}
                name={'clientName'}
                value={GetSolicitationDetails.data?.numeroProtocoloInterno}
              />
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {solicitationData?.faturas?.length > 0 ? (
          <Tabs initialTab={0}>
            {solicitationData?.faturas?.map((f) => {
              return (
                <Tabs.Tab
                  label={`Fatura ${moment(
                    f.dataVencimento,
                    'YYYY-MM-DD',
                  ).format('DD/MM/YYYY')}`}
                  disabled={false}
                >
                  <InvoiceView action readOnly data={f} />
                </Tabs.Tab>
              );
            })}
          </Tabs>
        ) : null}
      </Container>
    </>
  );
};

export default InvoiceReprocessPendingDetails;
